import { getContext } from 'typed-redux-saga';
import { type ContainerInstance } from 'typedi';
import { type ReduxSagaContext } from './types';

export function* getContainer(): Generator<
  unknown,
  ContainerInstance,
  unknown
> {
  return yield* getContext<ReduxSagaContext['container']>('container');
}
